import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const ResearchLineCard = ({margin, title, description, icon}) => {

    const styleWithMargin = 'relative flex flex-col min-w-0 mt-4';
    const styleWithoutMargin = 'relative flex flex-col min-w-0';

    return(
        <div className={margin ? styleWithMargin : styleWithoutMargin}>
            <div className="px-4 py-5 flex-auto">
                <div className="text-blueGray-500 p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-white">
                <FontAwesomeIcon icon={icon} />
                </div>
                <h6 className="text-xl mb-1 font-semibold">{title}</h6>
                <p className="mb-4 text-blueGray-500">
                {description}
                </p>
            </div>
        </div>
    )
}

export default ResearchLineCard;